import { inputProp } from "../../login";

 export const allInputs =(tags_list:any)=> [
    {
      label: "Genererate Image URL",
      placeholder: "Choose image",
      value: "",
      error: false,
      helperText: " c",
      endAdornment: "",
      fieldType: "image",
      // fullWidth: true,
      api: "logo_url",
      not_required: true,
    },
    {
      label: "Question",
      fullWidth: true,
      placeholder: "Enter Question",
      value: "",
      error: false,
      helperText: "",
      endAdornment: "",
      fieldType: "cktextEditor",
      api: "question",
    },
    {
      label: "Option A",
      placeholder: "Enter Option A",
      value: "",
      error: false,
      helperText: "",
      endAdornment: "",
      fieldType: "cktextEditor",
      dataType: "option",
      api: "option1",
    },
    {
      label: "Option B",
      placeholder: "Enter Option B",
      value: "",
      error: false,
      helperText: "",
      endAdornment: "",
      dataType: "option",
      fieldType: "cktextEditor",
      api: "option2",
    },
    {
      label: "Option C",
      placeholder: "Enter Option C",
      value: "",
      error: false,
      helperText: "",
      endAdornment: "",
      dataType: "option",
      fieldType: "cktextEditor",
      api: "option3",
    },
    {
      label: "Option D",
      placeholder: "Enter Option D",
      value: "",
      error: false,
      helperText: "",
      endAdornment: "",
      dataType: "option",
      fieldType: "cktextEditor",
      api: "option4",
    },
    {
      label: "Explanation",
      fullWidth: true,
      placeholder: "Enter Explanation",
      value: "",
      error: false,
      helperText: "",
      endAdornment: "",
      fieldType: "cktextEditor",
      api: "explanation",
      not_required: true,
    },
    {
      label: "Question Tags",
      list: tags_list ?? [],
      multiple: true,
      listLabel: "name",
      error: false,
      helperText: " ",
      endAdornment: "",
      fieldType: "autocomplete",
      not_required: true,
      freeSolo: {
        dialog: true,
      },
      api: "tag",
    },
  ] as inputProp[];